export default {
  // Hero
  'hero.badge': 'Contact Us',
  'hero.title': 'Let\u2019s talk about your packaging',
  'hero.subtitle':
    'From a single stock container to a fully custom program, our sourcing team is ready to answer your questions and get you a quote.',

  // Quick Contact
  'quick.label': 'Get in Touch',
  'quick.title': 'We respond fast',
  'quick.subtitle':
    'Reach us directly, or send a message below and our team will get back to you within one business day.',
  'quick.email.label': 'Email Us',
  'quick.email.desc': 'For inquiries, quotes and partnerships',
  'quick.phone.label': 'Call Us',
  'quick.phone.desc': 'Mon\u2013Fri, 09:00\u201318:00 (KST / CST)',
  'quick.response.label': 'Response Time',
  'quick.response.value': 'Within 1 business day',
  'quick.response.desc': 'Dedicated account managers for every region',

  // Locations
  'locations.label': 'Our Offices',
  'locations.title': 'Three locations, one global reach',
  'locations.subtitle':
    'With headquarters in Seoul and branches across China\u2019s key manufacturing hubs, we stay close to both our customers and our factories.',
  'locations.hq.badge': 'Headquarters',
  'locations.branch.badge': 'Branch',
  'locations.hq.name': 'Seoul \u2014 Seongsu-dong',
  'locations.hq.address': 'Seongsu-dong, Seongdong-gu, Seoul, South Korea',
  'locations.hq.note': 'Global sourcing & customer success',
  'locations.b1.badge': 'China Branch 1',
  'locations.b1.name': 'Shanghai \u2014 Minhang',
  'locations.b1.address': 'Minhang District, Shanghai, China',
  'locations.b1.note': 'East China sourcing & QC',
  'locations.b2.badge': 'China Branch 2',
  'locations.b2.name': 'Guangzhou \u2014 Baiyun',
  'locations.b2.address': 'Baiyun District, Guangzhou, China',
  'locations.b2.note': 'South China sourcing & logistics',

  // Form
  'form.label': 'Send a Message',
  'form.title': 'Tell us what you need',
  'form.subtitle':
    'Fill out the form and our team will reach out with pricing, samples, or next steps.',
  'form.name': 'Full Name',
  'form.name.placeholder': 'Your name',
  'form.email': 'Work Email',
  'form.email.placeholder': 'you@company.com',
  'form.company': 'Company',
  'form.company.placeholder': 'Your company name',
  'form.country': 'Country / Region',
  'form.country.placeholder': 'Select your country',
  'form.type': 'Inquiry Type',
  'form.type.general': 'General Inquiry',
  'form.type.quote': 'Request a Quote',
  'form.type.sample': 'Sample Request',
  'form.type.partnership': 'Supplier Partnership',
  'form.type.other': 'Other',
  'form.message': 'Message',
  'form.message.placeholder':
    'Tell us about the product, quantity, finishing, or timeline you have in mind\u2026',
  'form.submit': 'Send Message',
  'form.sending': 'Sending\u2026',
  'form.success.title': 'Message sent!',
  'form.success.desc':
    'Thank you for reaching out. Our team will get back to you within one business day.',
  'form.error.title': 'Something went wrong',
  'form.error.retry': 'Please try again.',
};